export default "__VITE_ASSET__DsNHlpYA__"